import {FC} from 'react';
import {useLocation} from 'react-router-dom';
import {ToastContainer, Zoom} from 'react-toastify';

import {cn} from 'App/utils/ui';
import font from 'Style/font';

import {DOM_ID} from '../../../constants';

const style = {
  notificationContainer: {
    fontFamily: font.family.sans,
    padding: '8px 16px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
  },
  closeButton: {
    margin: '4px 0 0 8px',
    fontSize: font.size.small,
  },
};

const CloseButton = ({closeToast}: {closeToast?: () => void}) => (
  <i className="icon-cancel" onClick={closeToast} style={style.closeButton} />
);

const NotificationContainer: FC = () => {
  const location = useLocation();
  const isSummary = location.pathname.includes('/summary');

  return (
    <div id={DOM_ID.notificationContainer}>
      <ToastContainer
        enableMultiContainer
        newestOnTop
        hideProgressBar
        closeOnClick={false}
        closeButton={<CloseButton />}
        autoClose={false}
        transition={Zoom}
        draggablePercent={30}
        className={cn('z-60 top-16', isSummary && 'top-32')}
      />
    </div>
  );
};

export default NotificationContainer;
